import { render, staticRenderFns } from "./unsupport.vue?vue&type=template&id=65cf2fde&"
import script from "./unsupport.vue?vue&type=script&lang=js&"
export * from "./unsupport.vue?vue&type=script&lang=js&"
import style0 from "./unsupport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports